import React, { useRef, useEffect, useState } from "react";
import "./AppPromotionSection.css";
import { GrAppleAppStore } from "react-icons/gr";
import { BiLogoPlayStore } from "react-icons/bi";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import mockupImage from "./01.png";

const AppDownload = () => {
  const sectionRef = useRef(null);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const obs = new IntersectionObserver(
      ([entry]) => {
        setVisible(entry.isIntersecting);
      },
      { threshold: 0.1 }
    );
    if (sectionRef.current) obs.observe(sectionRef.current);
    return () => obs.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="app-promotion-section">
      {/* Coluna do Mockup */}
      <div className="phone-mockup">
        <div className="phone-wrapper">
          <div className={`phone-back ${visible ? "animate" : ""}`} />
          <div className={`phone-back-2 ${visible ? "animate" : ""}`} />
          <div className={`phone-back-3 ${visible ? "animate" : ""}`} />
          <img src={mockupImage} className="app-image"></img>
          <div class="glow-circle"></div>

        </div>
      </div>

      {/* Coluna do Conteúdo Promocional */}
      <div className="promo-content">
        <h2>
          Baixe o App <span className="app-title-gradient">SETTE Fibra</span>
        </h2>
        <p>
          Tenha acesso ao seu consumo, faturas, suporte técnico e muito mais na
          palma da sua mão. Nosso aplicativo facilita a gestão da sua internet.
        </p>
        <ul className="promo-features">
          <li className="feature-item">
            <span className="feature-icon">
              <IoMdCheckmarkCircleOutline />
            </span>
            <span>Consulta de consumo em tempo real</span>
          </li>
          <li className="feature-item">
            <span className="feature-icon">
              <IoMdCheckmarkCircleOutline />
            </span>
            <span>Pagamento de faturas</span>
          </li>
          <li className="feature-item">
            <span className="feature-icon">
              <IoMdCheckmarkCircleOutline />
            </span>
            <span>Solicitar suporte técnico</span>
          </li>
          <li className="feature-item">
            <span className="feature-icon">
              <IoMdCheckmarkCircleOutline />
            </span>
            <span>Teste de velocidade integrado</span>
          </li>
        </ul>
        <div className="store-buttons">
          <a
            href="https://apps.apple.com/br/app/sette-fibra/id6711349663"
            className="store-button"
          >
            <span className="store-icon">
              <GrAppleAppStore />
            </span>
            <span>
              Disponível na <strong>App Store</strong>
            </span>
          </a>
          <a href="https://abrir.link/feCmF" className="store-button">
            <span className="store-icon">
              <BiLogoPlayStore />
            </span>
            <span>
              Disponível no <strong>Google Play</strong>
            </span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default AppDownload;
